/**
 * RESPONSIBILITY: mark a row that only an editor can see.
 *
 * Its own component because it appears on both shapes an event takes — the row and the
 * card, and on a ministry card too — and a badge that says two different things in two
 * places is a badge nobody trusts. The words come from the site's wording, like every other word on the site.
 */
import { useWords } from './words';

export function NotPublic() {
  const w = useWords();
  return <span className="ev-draft">{w.notPublicLabel}</span>;
}
